import { Container, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { useRef, useState } from 'react'
import FeedbackCard from '../Cards/FeedbackCard'
import Api from '../../Services/Api'
import { useEffect } from 'react'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

export default function StudentsFeedbackSection({ type, title }) {

    const [positionX, setPositionX] = useState(0)
    const [feedbacks, setFeedbacks] = useState([])

    const carousel = useRef(null)
    const titleRef = useRef(null)

    const classes = useStyles()
    const theme = useTheme()

    const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'))

    useEffect(() => {
        var depoimentType =
            type === 'residencia'
                ? 'sprint'
                : type === 'revalida'
                    ? 'revalida'
                    : type === 'extensivo'
                        ? 'extensivo'
                        : type === 'clinica medica'
                            ? 'extensivo'
                            : type === 'cirurgia geral'
                                ? 'extensivo'
                                : type === 'arena 2022'
                                    ? 'arena 2022'
                                    : type === 'Trilha R3'
                                        ? 'Trilha R3'
                                        : null
        Api.get(`depoimentos?tipo=${depoimentType}`).then((res) => {
            var feedbacks = res.filter((item) => {
                return item.dep_texto !== ''
            })
            if (feedbacks.length) setFeedbacks(feedbacks)
        })
    }, [type])

    useEffect(() => {
        const updatePosition = () => {
            if (titleRef.current) {
                const rect = titleRef.current.getBoundingClientRect()
                setPositionX(rect.left + window.scrollX)
            }
        }

        updatePosition()

        window.addEventListener("resize", updatePosition)
        window.addEventListener("scroll", updatePosition)

        return () => {
            window.removeEventListener("resize", updatePosition)
            window.removeEventListener("scroll", updatePosition)
        }
    }, [])

    const toggleExpandContainer = () => {
        return true;
    }

    const handleLeftClick = (e) => {
        carousel.current.scrollLeft -= carousel.current.offsetWidth;
    }

    const handleRightClick = (e) => {
        carousel.current.scrollLeft += 1380;
    }

    const handleRightClickMobile = (e) => {
        carousel.current.scrollLeft += carousel.current.offsetWidth;
    }

    return (

        <Container
            maxWidth={false}
            disableGutters={true}
            className={classes.containerFeedback}
        >
            <Container
                fixed
                maxWidth="xl"
                disableGutters={true}
                className={classes.sectionContainer}
            >
                <Grid
                    item
                    xs={12}
                    container
                    className={classes.container}
                >
                    <Grid
                        item
                        xs={12}
                        className={`${type === 'residencia'
                            ? 'residencia'
                            : type === 'extensivo'
                                ? 'residencia'
                                : type === 'clinica medica' || type === 'Trilha R3'
                                    ? 'clinica-medica'
                                    : type === 'cirurgia geral'
                                        ? 'cirurgia-geral'
                                        : 'revalida'
                            }`}
                    >
                        <Typography
                            ref={titleRef}
                            className={classes.subtitle1}
                            fontFamily={'Manrope'}
                        >
                            {title || 'Depoimentos de nossos alunos'}
                        </Typography>
                    </Grid>
                </Grid>
                {/* <Grid
					container
					alignContent="center"
					justifyContent="center"
					className={classes.section}
				>
					{' '}
				</Grid> */}
            </Container>

            <Grid
                item
                xs={12}
                container
                className={classes.feedbacksCarrousel}
                columnGap={4}
                ref={carousel}
                id={matchesMobile ? null : 'scroll-2'}
                style={{
                    ...(window.location.pathname === '/sprint-final-revalida' ||
                        window.location.pathname === '/sprint-final'
                        ? { overflowX: 'hidden' }
                        : {}),
                    paddingLeft: positionX,
                    paddingRight: positionX,
                }}
            >
                {feedbacks.map((item, index) => {
                    return (
                        <Grid
                            item
                            container
                            alignContent="flex-start"
                            key={index}
                        // className={classes.gridFeedbackCard}
                        >
                            <FeedbackCard
                                key={index}
                                toggleExpandContainer={toggleExpandContainer}
                                {...item}
                                type={type}
                            />
                        </Grid>
                    );
                })}
            </Grid>

            <Container
                fixed
                maxWidth="xl"
                disableGutters={true}
                className={classes.sectionContainer}
                style={
                    window.location.pathname === '/sprint-final-revalida' ||
                        window.location.pathname === '/sprint-final'
                        ? { marginBottom: '2rem' }
                        : null
                }
            >
                <Grid
                    container
                    alignContent="center"
                    justifyContent="center"
                    // className={classes.section}
                    style={{ maxWidth: 1410, margin: '0 auto' }}
                >
                    <Grid
                        item
                        xs={12}
                        columnGap={1}
                        className={classes.scrollControlContainer}
                    >
                        <IconButton
                            className={classes.buttonControl}
                            sx={{ backgroundColor: '#fff', color: '#000' }}
                            onClick={() => handleLeftClick()}
                        >
                            <ChevronLeft sx={{ fontSize: 24 }} />
                        </IconButton>

                        <IconButton
                            className={classes.buttonControl}
                            sx={{ backgroundColor: '#fff', color: '#000' }}
                            onClick={matchesMobile ? handleRightClickMobile : handleRightClick}
                        >
                            <ChevronRight sx={{ fontSize: 24 }} />
                        </IconButton>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    );
}

const useStyles = makeStyles((theme) => ({
    buttonControl: {
        '&:hover': {
            backgroundColor: '#e0e0e0 !important',
        }
    },
    feedbacksCarrousel: {
        width: '100vh',
        display: 'flex !important',
        overflowX: 'hidden',
        flexWrap: 'nowrap !important',
        position: 'relative',
        padding: '0 4%',
    },
    scrollControlContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        margin: '32px 0 !important',
    },
    section: {
        maxWidth: '1410px',
        margin: '5% auto',
        [theme.breakpoints.down('sm')]: {
            padding: '3vh 0 0 1em !important',
        },
    },
    title: {
        fontWeight: 'bold !important',
        fontSize: '3.75rem !important',
        lineHeight: '1 !important',
        [theme.breakpoints.down('lg')]: {
            fontSize: '2.75rem !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.6rem !important',
        },
    },
    subtitle1: {
        color: '#FCFCFC',
        fontSize: '2.5rem !important',
        fontWeight: 'bold !important',
        [theme.breakpoints.down('md')]: {
            lineHeight: 'unset !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.6rem !important',
            lineHeight: 'unset !important',
        },
    },
    containerFeedback: {
        backgroundColor: '#0D0D0F',
        [theme.breakpoints.down('lg')]: {
            // top: '50px',
        },
        [theme.breakpoints.down('md')]: {
            top: '0px',
        },
    },
    container: {
        maxWidth: '1410px !important',
        margin: '60px auto 32px !important',
    },
    sectionContainer: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '4%',
            paddingRight: '4%',
        },
    }
}));
